module.exports = __webpack_public_path__ + "static/media/ios-speedometer.b111eaaf.svg";